// libs
import 'prosemirror-view/style/prosemirror.css';

import React from 'react';

import { NewEditor } from '@lyearn/lygo-core';
import { cn } from '@lyearn/style';
// components
import { Box, Stack, Typography } from '@lyearn/ui';

// context
import { useEditorDetails } from '../../../context';
// styles
import { editorStyles } from './styles';

function EditorCore({
  variant,
  color,
  className = 'px-8 pb-16',
  classes,
  children,
  disableSelection = false,
  showEditor = true,
}: React.PropsWithChildren<Partial<React.ComponentProps<typeof Typography>>> & {
  classes?: { typography?: string; contentEditableContainer?: string };
  disableSelection?: boolean;
  showEditor?: boolean;
}) {
  const { onEditorFocus, editorProps } = useEditorDetails();

  return (
    <Box className={cn(className, 'ly-editor-core')}>
      <Typography
        as="div"
        className={cn(editorStyles, 'cursor-text', classes?.typography)}
        color={color}
        variant={variant ?? 'body-long-01'}
        onClick={onEditorFocus}>
        <Stack
          className={cn(classes?.contentEditableContainer, {
            // NOTE: use with `editorView.setProps({ editable: () => false });`
            // do not set `user-select-none`, it will reset the selection
            'pointer-events-none': disableSelection,
            hidden: !showEditor,
          })}>
          <NewEditor {...editorProps} />
        </Stack>
        {children}
      </Typography>
    </Box>
  );
}

export default EditorCore;
